var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isPhone)?_c('phone-page'):(_vm.isPad)?_c('pad-page'):_c('pc-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }